import { Component, OnInit } from "@angular/core";
import { DataService } from '../../shared/dataService';
import { Router } from '@angular/router';

@Component({
    selector: "login-page",
    templateUrl: "loginpage.component.html",
    styleUrls: []
})

export class LoginPage implements OnInit {
    
    constructor(private data: DataService, private router: Router) {
    }

    errorMessage: string = "";

    public creds = {
        username: "",
        password: ""
    }

    ngOnInit(): void {
        if (this.data.isAuthenticated())
            this.data.logout();
    }

    onLogin() {
        this.data.login(this.creds)
        .subscribe(success => {
            if(success){
                this.router.navigate(["/dashboard"]);
            }
        }, err => {
            this.errorMessage = "Failed to login";
            this.creds.password = "";
        });
    }
}